import axios from 'axios';
import { getToken } from '../auth';

const baseURL = process.env.VUE_APP_API_URL;

const client = axios.create({ baseURL });

/* Add an interceptor to the client to add the token in the 'Authorization' header */
client.interceptors.request.use(config => {
  const token = getToken()

  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }

  return config
})

export default client
